export const fileFormats = ['xls', 'csv', 'doc', 'rtf', 'pdf', 'ppt', 'pptx', 'zip', 'rar', 'png', 'jpg', 'jpeg', 'bmp', 'tif',
  'gif', 'flv', 'mov', 'mpg', 'mp4', 'key', 'xml', 'txt'];
